module.exports = __webpack_public_path__ + "static/media/2 (9).75efe9eb.jpg";